import { useReveal } from "@/hooks/useReveal";
import { IMAGES } from "@/data/content";

export function Company() {
  const head = useReveal();
  return (
    <section id="compagnie" data-testid="company-recto-verso-section" className="relative py-20 md:py-28 overflow-hidden bg-emerald-dark">
      <div className="absolute inset-0 opacity-30">
        <img src={IMAGES.stageEmotion} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, #16090A 0%, rgba(22,9,10,0.75) 60%, rgba(22,9,10,0.4) 100%)" }} />
      </div>
      <div ref={head.ref} className={`relative max-w-7xl mx-auto px-4 sm:px-8 ${head.className}`}>
        <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-mustard mb-3">La compagnie</p>
        <h2 className="font-display font-black text-4xl md:text-6xl tracking-tight text-cream">
          Recto — Verso
        </h2>
        <div className="mt-6 max-w-2xl space-y-4 text-cream/85 leading-relaxed">
          <p>
            Notre compagnie professionnelle compte 6 danseurs et porte les créations de l'AJDR
            sur les scènes. Sa dernière création, <span className="text-mustard font-semibold">« DClic »</span>,
            est chorégraphiée par Djamel KOOB.
          </p>
          <p>
            Entremêlant danse hip-hop, breakdance, house et contemporain, ce spectacle met en scène
            la relation complexe entre un père et sa fille à travers le monde numérique et les nouvelles technologies.
          </p>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          {["Hip-Hop", "Break", "House", "Contemporain"].map((t) => (
            <span key={t} className="rounded-full px-4 py-1.5 text-sm font-mono2 border border-mustard/40 text-mustard">{t}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
